<script>
  export let checked
</script>

<span 
  class="toggle" 
  class:checked
  on:click={() => checked = !checked}>
  <span class="thumb"></span>
</span>

<style>
  .toggle {
    position: relative;
    display: inline-block;
    width: 2.8rem;
    height: 1.6rem;
    margin: 0.2rem 0;
    background-color: var(--c-text-faded);
    border-radius: 0.8rem;
    cursor: pointer;
    transition: background-color var(--transition-props);
    transition-duration: 0.25s;
  }
  .toggle .thumb {
    position: absolute;
    top: 0rem;
    left: 0;
    display: inline-block;
    width: 1.6rem;
    height: 1.6rem;
    border: 0.2rem solid var(--c-text-faded);
    border-radius: 0.8rem;
    background-color: var(--c-bg);
    transition: border, left var(--transition-props);
    transition-duration: 0.25s;
  }
  .toggle.checked {
    background-color: var(--c-accent);
  }
  .toggle.checked .thumb {
    border-color: var(--c-accent);
    left: 1.2rem;
  }
  .toggle:not(.checked):hover {
    background-color: var(--c-text);
  }
  .toggle:not(.checked):hover .thumb {
    border-color: var(--c-text);
  }
</style>